import i18n from "i18next";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWrapper } from "../../../helpers/fetchwrapper";

// Fluent UI Imports
import { baseUrl } from "../../../helpers/constants";
import { ValidatePassword } from "../../../helpers/passwordValidator";
import useWindowSize from "../../../helpers/useWindowSize";
import {
  MessageBar,
  ProgressBar,
  Link,
  Spinner,
  Image,
  Button,
  Field,
  Input,
  Option,
  Dropdown,
  Text,
  Checkbox,
  Combobox,
} from "@fluentui/react-components";
import {
  ArrowLeftRegular,
  ArrowRightRegular,
  HomeRegular,
} from "@fluentui/react-icons";
import { StackItemShim, StackShim } from "@fluentui/react-migration-v8-v9";
import { ILuebOption } from "../../../Models/ILuebOption";

var emailRegEx = /\S+@\S+\.\S+/;
function Register(props: any) {
  const modul = window.location?.search?.substring(
    window.location?.search?.indexOf("&modul=") + 8,
  );

  const [emailValid, setEmailValid] = useState(false);
  const [anredeKey, setAnredeKey] = useState("herr");
  const navigate = useNavigate();

  const [countries, setCountries] = useState<ILuebOption[]>([]);
  const [arbeitsgebiete, setArbeitsgebiete] = useState<ILuebOption[]>([]);
  const [branchen, setBranchen] = useState<ILuebOption[]>([]);

  const [loading, setLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState(
    i18n.t<string>("pwdNotValid") ? i18n.t<string>("pwdNotValid") : "",
  );
  const [mailInUseError, setMailInUseError] = useState(false);
  const [registerValues, setRegisterValues] = useState({
    Anrede: "Herr",
    Vorname: "",
    Nachname: "",
    Email: "",
    Firma: "",
    Abteilung: "",
    Webseite: "",
    Strasse: "",
    Hausnummer: "",
    Postleitzahl: "",
    Stadt: "",
    LandGuid: "5ac74f63-2abb-4e48-93dc-42e613f99aff",
    TelefonNummer: "",
    Kundennummer: "",
    Password: "",
    PasswordConfirmed: "",
    Sprache: i18n.language.includes("de") ? "de" : "en",
    Modul: modul ? modul : "",
    AgreeDataStore: false,
    SendNewsLetter: false,
    BranchenKeys: [],
    ArbeitsgebieteKeys: [],
  });

  const [passwordStrength, setPasswordStrength] = useState(0);

  const handleRegisterValuesChange = (name: string, val: any) => {
    setRegisterValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
  };

  let anredeOptions: ILuebOption[] = [
    { key: "herr", text: i18n.t<string>("herr") },
    { key: "frau", text: i18n.t<string>("frau") },
  ];

  const CheckValidEMail = (value: string): string => {
    if (emailRegEx.test(value)) {
      setEmailValid(true);
      return "";
    } else {
      setEmailValid(false);
      return i18n.t<string>("enterValidEMail");
    }
  };

  const getCountries = () => {
    fetchWrapper.get(`${baseUrl}/api/account/getcountries`).then((result) => {
      let options: ILuebOption[] = [];
      result.forEach((element: any) => {
        let option: ILuebOption = {
          key: element.landGuid,
          text: i18n.language.includes("de")
            ? element.name_DE
            : element.name_EN,
        };
        options.push(option);
      });

      options.sort((a, b) => a.text.localeCompare(b.text));

      setCountries(options);
    });
  };

  const getBranchen = () => {
    fetchWrapper.get(`${baseUrl}/api/account/getbranchen`).then((result) => {
      let options: ILuebOption[] = [];
      result.forEach((element: any) => {
        let option: ILuebOption = {
          key: element.brancheGuid,
          text: i18n.language.includes("de") ? element.nameDE : element.nameEN,
        };
        options.push(option);
      });
      setBranchen(options);
    });
  };

  const getArbeitsgebiete = () => {
    fetchWrapper
      .get(`${baseUrl}/api/account/getarbeitsgebiete`)
      .then((result: any[]) => {
        result = result.sort((a, b) =>
          i18n.language.includes("de")
            ? a.nameDE < b.nameDE
              ? -1
              : 1
            : a.nameEN < b.nameEN
            ? -1
            : 1,
        );
        let options: ILuebOption[] = [];
        result.forEach((element: any) => {
          let option: ILuebOption = {
            key: element.arbeitsgebietGuid,
            text: i18n.language.includes("de")
              ? element.nameDE
              : element.nameEN,
          };
          options.push(option);
        });
        setArbeitsgebiete(options);
      });
  };

  const [registerState, setRegisterState] = useState(1);

  const RegisterNow = (): void => {
    if (FormValidation()) {
      setLoading(true);
      fetchWrapper
        .post(`${baseUrl}/api/account/register`, registerValues)
        .then((result) => {
          if (result.message == "ACCOUNT_CREATED") {
            setRegisterState(3);
          } else if (result.message.length > 0) {
            setErrorMessage(result.message);
          } else {
          }
        })
        .catch((error) => {
          setErrorMessage(i18n.t<string>(error));
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const checkIfMailIsInUse = () => {
    setLoading(true);
    fetchWrapper
      .post(`${baseUrl}/api/account/CheckMailInUse`, {
        email: registerValues.Email,
      })
      .then((result) => {
        if (result.message == "MAIL_NOT_IN_USE") {
          setRegisterState(2);
        }
      })
      .catch((error) => {
        setMailInUseError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const FormValidation = (): boolean => {
    if (
      emailRegEx.test(registerValues.Email) &&
      errorMessage == "" &&
      registerState == 1
    ) {
      // TODO: Check if E-Mail already registered
      checkIfMailIsInUse();
      return true;
    } else if (registerState == 2) {
      if (registerValues.Anrede == "") {
        return false;
      }
      if (registerValues.Vorname == "") {
        return false;
      }
      if (registerValues.Nachname == "") {
        return false;
      }
      if (registerValues.Firma == "") {
        return false;
      }
      if (registerValues.Strasse == "") {
        return false;
      }
      if (registerValues.Hausnummer == "") {
        return false;
      }
      if (registerValues.Postleitzahl == "") {
        return false;
      }
      if (registerValues.Stadt == "") {
        return false;
      }
      if (!registerValues.AgreeDataStore) {
        return false;
      }
      return true;
    } else {
      return true;
    }
  };

  const CheckValidPassword = (changedField: string, value: string): void => {
    let password = "";
    let confirmPassword = "";

    if (changedField == "Password") {
      password = value;
      confirmPassword = registerValues.PasswordConfirmed;
    } else {
      password = registerValues.Password;
      confirmPassword = value;
    }

    const result = ValidatePassword(password);
    setPasswordStrength(result / 100);

    if (result < 100) {
      setErrorMessage(i18n.t<string>("pwdNotValid"));
    } else if (password != confirmPassword) {
      setErrorMessage(i18n.t<string>("pwNotMatching"));
    } else {
      setErrorMessage("");
    }
  };

  useEffect(() => {
    // Laender laden
    getCountries();
    getBranchen();
    getArbeitsgebiete();
  }, []);

  const windowSize = useWindowSize();

  return (
    <div>
      {registerState == 1 && (
        <div className="blockContainerContentCentered">
          <div
            style={{
              borderRadius: "11px",
              backgroundColor: "white",
              boxShadow: "0px 6px 12px 5px silver",
              minWidth: windowSize.width < 400 ? windowSize.width - 40 : 400,
              maxWidth: 500,
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: 20,
              marginBottom: 20,
              animationDuration: "4s",
            }}
          >
            <div style={{ padding: 20 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Link onClick={() => navigate("/")}>
                  <Image
                    src={"/LUEBBERING_DIGITAL_512X512PX.PNG"}
                    height={50}
                    className="lueb-MarginBottom30"
                  />
                </Link>
              </div>
              <div className="lueb-padding5 lueb-MarginTopBottom10">
                <form
                  onSubmit={() => {
                    FormValidation();
                  }}
                >
                  <StackShim horizontal className="lueb-MarginTopBottom10">
                    <Button
                      appearance="transparent"
                      onClick={() => {
                        navigate("/account/login");
                      }}
                      icon={<ArrowLeftRegular />}
                    />
                    <h3 style={{ marginBottom: "0px" }}>
                      {i18n.t<string>("register")}
                    </h3>
                  </StackShim>
                  <div className="lueb-MarginTopBottom10">
                    <Text>{i18n.t<string>("basicInformation")}</Text>
                  </div>
                  <Field label={"E-Mail"}>
                    <Input /* 
                      className="lueb-MarginBottom10" */
                      appearance="underline"
                      value={registerValues.Email}
                      placeholder="E-Mail"
                      name="email"
                      onChange={(ev, data) => {
                        CheckValidEMail(data ? data.value : "");
                        handleRegisterValuesChange(
                          "Email",
                          data ? data.value : "",
                        );
                        if (mailInUseError) {
                          setMailInUseError(false);
                        }
                      }}
                    />
                  </Field>

                  {!emailValid && (
                    <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                      <MessageBar intent={"error"}>
                        {i18n.t<string>("enterValidEMail")}
                      </MessageBar>
                    </div>
                  )}
                  <Field
                    style={{ marginTop: "5px" }}
                    label={i18n.t<string>("password")}
                  >
                    <Input
                      appearance="underline"
                      placeholder={i18n.t<string>("password")}
                      type="password"
                      name="new-password"
                      onKeyDown={() => {
                        if (
                          !mailInUseError ||
                          errorMessage == "" ||
                          registerValues.Password != "" ||
                          registerValues.PasswordConfirmed != "" ||
                          !loading
                        ) {
                          FormValidation();
                        }
                      }}
                      value={registerValues.Password}
                      onChange={(ev, data) => {
                        handleRegisterValuesChange("Password", data.value);
                        CheckValidPassword("Password", data.value);
                      }}
                    />
                  </Field>
                  <Field
                    style={{ marginTop: "5px" }}
                    label={i18n.t<string>("confirmPassword")}
                  >
                    <Input
                      appearance="underline"
                      type="password"
                      placeholder={i18n.t<string>("confirmPassword")}
                      name="new-password"
                      value={registerValues.PasswordConfirmed}
                      onKeyDown={() => {
                        if (
                          !mailInUseError ||
                          errorMessage == "" ||
                          registerValues.Password != "" ||
                          registerValues.PasswordConfirmed != "" ||
                          !loading
                        ) {
                          FormValidation();
                        }
                      }}
                      onChange={(ev, data) => {
                        handleRegisterValuesChange(
                          "PasswordConfirmed",
                          data ? data.value : "",
                        );
                        CheckValidPassword(
                          "PasswordConfirmed",
                          data ? data.value : "",
                        );
                      }}
                    />
                  </Field>

                  {passwordStrength > 0.0 && passwordStrength < 1.0 && (
                    /* <ProgressIndicator percentComplete={passwordStrength} /> */
                    <ProgressBar
                      style={{ marginTop: "5px", marginBottom: "5px" }}
                      value={passwordStrength}
                      thickness="large"
                    />
                  )}
                  <div style={{ marginTop: "5px", marginBottom: "5px" }}>
                    {errorMessage != "" && (
                      <MessageBar intent={"error"}>{errorMessage}</MessageBar>
                    )}
                    {mailInUseError && (
                      <MessageBar intent={"error"}>
                        {i18n.t<string>("mailInUse")}
                      </MessageBar>
                    )}
                  </div>
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      appearance="primary"
                      /* iconProps={{ iconName: "AddFriend" }} */
                      icon={<ArrowRightRegular />}
                      iconPosition="after"
                      disabled={
                        mailInUseError ||
                        errorMessage != "" ||
                        registerValues.Password == "" ||
                        registerValues.PasswordConfirmed == "" ||
                        loading
                      }
                      onClick={() => {
                        FormValidation();
                      }}
                    >
                      {loading ? <Spinner></Spinner> : i18n.t<string>("next")}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {registerState == 2 && (
        <div className="blockContainerContentCentered">
          <div
            style={{
              borderRadius: "11px",
              backgroundColor: "white",
              boxShadow:
                "0 0 8px rgba(0,0,0,0.12), 0 32px 64px rgba(0,0,0,0.14)",
              minWidth: windowSize.width < 400 ? windowSize.width - 40 : 400,
              maxWidth: 500,
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: 20,
              marginBottom: 20,
              animationDuration: "4s",
            }}
          >
            <div style={{ padding: 20 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Link onClick={() => navigate("/")}>
                  <Image
                    src={"/LUEBBERING_DIGITAL_512X512PX.PNG"}
                    height={50}
                    className="lueb-MarginBottom30"
                  />
                </Link>
              </div>
              <div className="lueb-padding5 lueb-MarginTopBottom10">
                <form
                  onSubmit={() => {
                    RegisterNow();
                  }}
                >
                  <StackShim
                    horizontal
                    className="lueb-MarginTopBottom10"
                    verticalAlign="stretch"
                  >
                    <Button
                      appearance="transparent"
                      icon={<ArrowLeftRegular />}
                      title="Back"
                      onClick={() => setRegisterState(1)}
                    />
                    <h3 style={{ marginBottom: "0px" }}>
                      {i18n.t<string>("register")}
                    </h3>
                  </StackShim>
                  <div className="lueb-MarginTopBottom10">
                    <Text>{i18n.t<string>("moreInformation")}</Text>
                  </div>
                  <div className="lueb-MarginBottom20 lueb-flexSpaceBetween">
                    <StackShim
                      tokens={{ childrenGap: 5 }}
                      horizontal
                      wrap={true}
                    >
                      <StackItemShim
                        grow={1}
                        style={{
                          marginTop: 8,
                          marginLeft: 5,
                          marginRight: 5,
                        }}
                      >
                        <Field>
                          <Dropdown
                            className="lueb-marginRight10"
                            selectedOptions={[anredeKey]}
                            value={
                              anredeKey == "herr"
                                ? i18n.t<string>("herr")
                                : i18n.t<string>("frau")
                            }
                            defaultValue={
                              anredeKey == "herr"
                                ? i18n.t<string>("herr")
                                : i18n.t<string>("frau")
                            }
                            onOptionSelect={(ev, val) => {
                              if (val.optionText && val.optionValue) {
                                handleRegisterValuesChange(
                                  "Anrede",
                                  val.optionText,
                                );
                                setAnredeKey(val.optionValue.toString());
                              }
                            }}
                          >
                            {anredeOptions.map((item) => {
                              if (typeof item.key == "string") {
                                return (
                                  <Option value={item.key}>{item.text}</Option>
                                );
                              }
                            })}
                          </Dropdown>
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        <Field>
                          <Input
                            name="given-name"
                            className="lueb-Stretch"
                            style={{
                              background:
                                registerValues.Vorname == ""
                                  ? "#FDE7E9"
                                  : undefined,
                            }}
                            appearance="underline"
                            placeholder={i18n.t<string>("firstName")}
                            value={registerValues.Vorname}
                            onChange={(ev: any, data) =>
                              handleRegisterValuesChange("Vorname", data.value)
                            }
                          />
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        <Field>
                          <Input
                            className="lueb-MarginBottom10"
                            style={{
                              background:
                                registerValues.Nachname == ""
                                  ? "#FDE7E9"
                                  : undefined,
                            }}
                            appearance="underline"
                            name="family-name"
                            placeholder={i18n.t<string>("lastName")}
                            value={registerValues.Nachname}
                            onChange={(ev: any, data) =>
                              handleRegisterValuesChange("Nachname", data.value)
                            }
                          />
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        <Field>
                          <Input
                            className="lueb-MarginBottom10"
                            style={{
                              background:
                                registerValues.Firma == ""
                                  ? "#FDE7E9"
                                  : undefined,
                            }}
                            appearance="underline"
                            name="organization"
                            placeholder={i18n.t<string>("company")}
                            value={registerValues.Firma}
                            onChange={(ev: any, data) =>
                              handleRegisterValuesChange("Firma", data.value)
                            }
                          />
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        <Field>
                          <Input
                            className="lueb-MarginBottom10"
                            appearance="underline"
                            placeholder={i18n.t<string>("department")}
                            value={registerValues.Abteilung}
                            onChange={(ev: any, data) =>
                              handleRegisterValuesChange(
                                "Abteilung",
                                data.value,
                              )
                            }
                          />
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        <Field>
                          <Input
                            className="lueb-MarginBottom10"
                            appearance="underline"
                            name="url"
                            prefix="https://"
                            placeholder="Website"
                            value={registerValues.Webseite}
                            onChange={(ev: any, data) =>
                              handleRegisterValuesChange("Webseite", data.value)
                            }
                          />
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        <Field>
                          <Input
                            className="lueb-MarginBottom10"
                            appearance="underline"
                            name="tel"
                            placeholder={i18n.t<string>("telephone")}
                            value={registerValues.TelefonNummer}
                            onChange={(ev: any, data) => {
                              handleRegisterValuesChange(
                                "TelefonNummer",
                                data.value,
                              );
                            }}
                          />
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        <Field>
                          <Input
                            name="street-address"
                            className="lueb-marginBottom10"
                            style={{
                              background:
                                registerValues.Strasse == ""
                                  ? "#FDE7E9"
                                  : undefined,
                            }}
                            appearance="underline"
                            placeholder={i18n.t<string>("street")}
                            value={registerValues.Strasse}
                            onChange={(ev: any, data) =>
                              handleRegisterValuesChange("Strasse", data.value)
                            }
                          />
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        {" "}
                        <Field>
                          <Input
                            style={{
                              background:
                                registerValues.Hausnummer == ""
                                  ? "#FDE7E9"
                                  : undefined,
                            }}
                            appearance="underline"
                            name="houseno"
                            placeholder={i18n.t<string>("houseNo")}
                            value={registerValues.Hausnummer}
                            onChange={(ev: any, data) =>
                              handleRegisterValuesChange(
                                "Hausnummer",
                                data.value,
                              )
                            }
                          />
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        <Field>
                          <Input
                            name="postal-code"
                            className="lueb-marginBottom10"
                            appearance="underline"
                            placeholder={i18n.t<string>("zip")}
                            value={registerValues.Postleitzahl}
                            onChange={(ev: any, data) =>
                              handleRegisterValuesChange(
                                "Postleitzahl",
                                data.value,
                              )
                            }
                            style={{
                              background:
                                registerValues.Postleitzahl == ""
                                  ? "#FDE7E9"
                                  : undefined,
                            }}
                          />
                        </Field>
                      </StackItemShim>
                      <StackItemShim
                        grow={1}
                        style={{ marginLeft: 5, marginRight: 5 }}
                      >
                        <Field>
                          <Input
                            name="address-level2"
                            style={{
                              background:
                                registerValues.Stadt == ""
                                  ? "#FDE7E9"
                                  : undefined,
                            }}
                            className="lueb-Stretch"
                            appearance="underline"
                            placeholder={i18n.t<string>("city")}
                            value={registerValues.Stadt}
                            onChange={(ev: any, data) =>
                              handleRegisterValuesChange("Stadt", data.value)
                            }
                          />
                        </Field>
                      </StackItemShim>
                    </StackShim>
                  </div>
                  <Field label={i18n.t<string>("country")}></Field>
                  <Combobox
                    /* allowFreeform */
                    autoComplete="on"
                    onOptionSelect={(ev, val) => {
                      if (val) {
                        {
                          handleRegisterValuesChange(
                            "LandGuid",
                            val.optionValue,
                          );
                        }
                      }
                    }}
                    selectedOptions={[registerValues.LandGuid]}
                    value={
                      countries.find((x) => x.key == registerValues.LandGuid)
                        ?.text
                    }
                  >
                    {countries.map((item) => {
                      if (typeof item.key == "string") {
                        return <Option value={item.key}>{item.text}</Option>;
                      }
                    })}
                  </Combobox>

                  <Field label={i18n.t<string>("branchen")}>
                    <Dropdown
                      onOptionSelect={(ev, data) => {
                        handleRegisterValuesChange(
                          "BranchenKeys",
                          data.selectedOptions,
                        );
                      }}
                      multiselect={true}
                      selectedOptions={registerValues.BranchenKeys}
                    >
                      {branchen.map((item) => {
                        if (typeof item.key == "string") {
                          return <Option value={item.key}>{item.text}</Option>;
                        }
                      })}
                    </Dropdown>
                  </Field>

                  <Field label={i18n.t<string>("arbeitsgebiete")}>
                    <Dropdown
                      onOptionSelect={(ev, data) => {
                        handleRegisterValuesChange(
                          "ArbeitsgebieteKeys",
                          data.selectedOptions,
                        );
                      }}
                      multiselect={true}
                      selectedOptions={registerValues.ArbeitsgebieteKeys}
                    >
                      {arbeitsgebiete.map((item) => {
                        if (typeof item.key == "string") {
                          return <Option value={item.key}>{item.text}</Option>;
                        }
                      })}
                    </Dropdown>
                  </Field>

                  <StackShim tokens={{ childrenGap: 15 }}>
                    <Checkbox
                      checked={registerValues.AgreeDataStore}
                      onChange={(ev, data) =>
                        handleRegisterValuesChange(
                          "AgreeDataStore",
                          data.checked,
                        )
                      }
                      style={{
                        marginTop: "8px",
                        background: !registerValues.AgreeDataStore
                          ? "#FDE7E9"
                          : undefined,
                      }}
                      label={
                        i18n.language.includes("de") ? (
                          <span>
                            <Text>{i18n.t<string>("acceptTermsPre")}</Text>
                            <Link
                              href={`${baseUrl}/termsofuse`}
                              target="_blank"
                            >
                              {i18n.t<string>("acceptTerms")}
                            </Link>
                            <Text>{i18n.t<string>("acceptTermsPost")}</Text>
                          </span>
                        ) : (
                          <span>
                            <Text>{i18n.t<string>("acceptTermsPre")}</Text>
                            <Link
                              href={`${baseUrl}/termsofuse`}
                              target="_blank"
                            >
                              {i18n.t<string>("acceptTerms")}
                            </Link>
                          </span>
                        )
                      }
                    />
                    <Checkbox
                      checked={registerValues.SendNewsLetter}
                      onChange={(ev, data) =>
                        handleRegisterValuesChange(
                          "SendNewsLetter",
                          data.checked,
                        )
                      }
                      style={{
                        verticalAlign: "top",
                      }}
                      label={i18n.t<string>("sendNewsletter")}
                    />
                  </StackShim>
                  {errorMessage != "" && (
                    <MessageBar intent={"error"}>{errorMessage}</MessageBar>
                  )}
                  <div
                    style={{
                      marginTop: "10px",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      appearance="primary"
                      icon={<ArrowRightRegular />}
                      iconPosition="after"
                      disabled={!FormValidation() || loading}
                      onClick={() => {
                        RegisterNow();
                      }}
                    >
                      {loading ? <Spinner></Spinner> : i18n.t<string>("next")}
                    </Button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
      {registerState == 3 && (
        <div className="blockContainerContentCentered">
          <div
            style={{
              borderRadius: "11px",
              backgroundColor: "white",
              boxShadow: "0px 6px 12px 5px silver",
              minWidth: windowSize.width < 400 ? windowSize.width - 40 : 400,
              maxWidth: 500,
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: 20,
              marginBottom: 20,
              animationDuration: "4s",
            }}
          >
            <div style={{ padding: 20 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <Link onClick={() => navigate("/")}>
                  <Image
                    src={"/LUEBBERING_DIGITAL_512X512PX.PNG"}
                    height={50}
                    className="lueb-MarginBottom30"
                  />
                </Link>
              </div>
              <StackShim horizontal className="lueb-MarginTopBottom10">
                <h3 style={{ marginBottom: "0px" }}>
                  {i18n.t<string>("registerSuccessful")}
                </h3>
              </StackShim>
              <div className="lueb-MarginTopBottom10">
                {i18n
                  .t("registerSuccessfulText")
                  .split("\n")
                  .map((item) => {
                    return (
                      <div className="lueb-MarginTopBottom10">
                        <Text>{item}</Text>
                      </div>
                    );
                  })}
              </div>
              <Button
                /* iconProps={{ iconName: "Back" }} */
                icon={<HomeRegular />}
                appearance="primary"
                onClick={() => navigate("/")}
              >
                {i18n.t<string>("backToHome")}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Register;
